// Plugins
import '../js/plugins/slick';
import '../js/plugins/jquery.openClose';
import '../js/plugins/select2.full';
import '../js/plugins/owl.carousel.min';


// Behaviors:

import '../js/behaviors/search';
import '../js/behaviors/accordion-opener';
import '../js/behaviors/menu';
import '../js/behaviors/mobile-sidebar';
import '../js/behaviors/share-link';
import '../js/behaviors/isVisible';
import '../js/behaviors/counterUp';
import '../js/behaviors/video-block';
import '../js/behaviors/columns-text';
import '../js/behaviors/timeline';
import '../js/behaviors/toggle-show-text';
import '../js/behaviors/filter';
import '../js/behaviors/home-timeline';
import '../js/behaviors/tabs-animation';
import '../js/behaviors/home-slider';
import '../js/behaviors/faq-toggle';
import '../js/behaviors/link-toggle';
import '../js/behaviors/thematic-slider';
import '../js/behaviors/mag-running-slider';
import '../js/behaviors/select';
import '../js/behaviors/filter-carousel';
import '../js/behaviors/troubles-slider';
import '../js/behaviors/story-slider';
import '../js/behaviors/back-button';
import '../js/behaviors/mag-thematic-lists';
import '../js/behaviors/header';
import '../js/behaviors/text-limited';
import '../js/behaviors/video-bg';
import '../js/behaviors/recette';
import '../js/behaviors/astuces';
import '../js/behaviors/tutorial';
import '../js/behaviors/cuisine';
import '../js/behaviors/cuisine-a-la-carte';
import '../js/behaviors/conseils-adaptes';
import '../js/behaviors/recettes';
import '../js/behaviors/accordeons';
import '../js/behaviors/accordeons-footer.js';
import '../js/behaviors/breadcrumb-mobile';
